import '../FiltersSection/FiltersSection.css';
import { SearchAndActionsProps } from './SearchAndActions.types';

/**
 * Search and actions component providing search input and export functionality
 * Contains search input field and Excel export button for authorized users
 *
 * Features:
 * - Real-time search input with placeholder text
 * - Excel export button with permission-based visibility
 * - Disabled states when data is not initialized
 * - Responsive design for mobile and desktop
 *
 * @param props - Component props containing search state and callbacks
 * @returns JSX element containing search input and action buttons
 */
export function SearchAndActions({
  isMobile,
  searchQuery,
  dataInitialized,
  canExport,
  onSearchChange,
  onExport
}: SearchAndActionsProps) {
  return (
    <div className={`azk-list-search-actions ${isMobile ? 'mobile' : ''}`}>
      <div className="azk-list-search-container">
        <input
          className="azk-list-search-input"
          value={searchQuery}
          onChange={(e: any) => onSearchChange(e.target.value)}
          placeholder="Пошук"
          disabled={!dataInitialized}
        />
      </div>

      {canExport && (
        <button
          className={`azk-list-export-button ${!dataInitialized ? 'disabled' : ''}`}
          onClick={onExport}
          disabled={!dataInitialized}
        >
          Вивантажити Excel
        </button>
      )}
    </div>
  );
}
